<template>
  <!--  <div class="join-challenge">-->
  <!--    <challenge-layout-->
  <!--      :with-ribbon="false"-->
  <!--      :time-until-challenge-start="timeUntilChallengeStart"-->
  <!--      :challenge-header-props="{-->
  <!--        challengeName: challenge.name,-->
  <!--        shortDescription: challenge.shortDescription ?? '',-->
  <!--        descriptionSize: DescriptionSize.LARGE,-->
  <!--      }"-->
  <!--    >-->
  <!--      <template v-slot:info>-->
  <!--        <div class="challenge-info padding-bottom-l">-->
  <!--          <div class="info padding-vertical-ml">-->
  <!--            <slot name="info-by-challenge-type" />-->
  <!--            <duration-summary-->
  <!--              :challenge-start-date="challenge.startDate"-->
  <!--              :challenge-end-date="challenge.endDate"-->
  <!--            />-->
  <!--          </div>-->
  <!--          <participant-summary :number-of-participants="challenge.participants.length" />-->
  <!--          <span class="ri-body padding-top-m">{{ challenge.challengeParams?.joinCta }}</span>-->
  <!--        </div>-->
  <!--      </template>-->
  <!--    </challenge-layout>-->
  <!--    <div class="sticky-button-wrapper">-->
  <!--      <riseup-button-->
  <!--        class="join-challenge-button"-->
  <!--        :title="buttonTitle ?? 'הצטרפות לאתגר'"-->
  <!--        size="slim"-->
  <!--        :loading="loading"-->
  <!--        :disabled="loading"-->
  <!--        :action="onClick"-->
  <!--      />-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="loader-container">
    <tiny-loader />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { useRouteQuery } from '@vueuse/router';
import TinyLoader from '@riseupil/base-ui/src/components/TinyLoader/TinyLoader.vue';
import { onMounted } from 'vue';
import ChallengeLayout from '../../layouts/ChallengeLayout.vue';
import ParticipantSummary from '../ChallengeInfo/ParticipantSummary.vue';
import { DescriptionSize } from '../ChallengeHeader/DescriptionSize';
import { useChallengeStore } from '../../stores/challenge';
import Segment from '../../Segment';
import DurationSummary from '../ChallengeInfo/DurationSummary.vue';

interface Props {
  onClick: (newVal?: string)=> void;
  buttonTitle?: string;
}
defineProps<Props>();

const source = useRouteQuery<string>('source');
const challengeStore = useChallengeStore();
const {
  challenge,
  hasChallengeStarted,
  loading,
  timeUntilChallengeStart,
} = storeToRefs(challengeStore);

onMounted(async () => {
  await challengeStore.addParticipant();
});

Segment.trackUserGot(
  'join_challenge_page',
  { hasChallengeStarted: hasChallengeStarted.value, challengeId: challenge?.value?.challengeId, source: source.value },
);

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/mixins';
@import '@riseupil/base-ui/src/scss/spacings';

.loader-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
}
.join-challenge {

  @include white-page-frame;
  height: 100%;
  flex-grow: 1;
  .header-section {
    display: flex;
    align-items: center;
    height: 230px;
  }

  .challenge-info {
    display: flex;
    flex-direction: column;

    .info {
      display: flex;
      flex-direction: column;
      justify-items: center;
      border-bottom: 1px solid $riseup_gray_0;
      width: 100%;
      gap: $ri-spacing-sm;
    }
  }

  .sticky-button-wrapper {
    position: sticky;
    bottom: 0;
    width: 100%;
    padding: 24px;
    background-color: $riseup-white;
    box-shadow: 0px -2px 5px rgba(132, 132, 132, 0.1);
    .join-challenge-button {
      height: 54px;
      width: 100%;
    }
  }
}
</style>
